export default function FeaturesSection() {
  const features = [
    {
      icon: "ri-book-open-line",
      title: "海量韩漫资源",
      desc: "收录上千部韩国漫画，从人气连载到经典完结，全方位满足阅读需求",
    },
    {
      icon: "ri-smartphone-line",
      title: "下拉式阅读",
      desc: "专为移动端优化的下拉式阅读体验，流畅翻页，沉浸式享受漫画世界",
    },
    {
      icon: "ri-shield-check-line",
      title: "完全免费",
      desc: "所有漫画资源免费阅读，无需付费订阅，随时随地畅享韩漫乐趣",
    },
    {
      icon: "ri-flashlight-line",
      title: "每日更新",
      desc: "追踪最新韩漫动态，每日同步更新最新章节，精彩内容不错过",
    },
  ];

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
            为什么选择韩漫之家？
          </h2>
          <p className="text-sm text-foreground-600 mt-2">为您打造极致的韩漫阅读体验</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((feature, index) => (
            <div
              key={index}
              className="flex flex-col items-center text-center p-6 rounded-lg bg-background-50 border border-background-200/70"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 mb-4">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}